<div class="donationdrive-modal-parent">
  <div class="ui_modal donationdrive-modal">
    <a href="javascript:void(0)" class="ui_close" (click)="action('closeButton')"></a>
    <div class="ui_modal_text">{{donationDrive.name}}</div>
    <div class="ui_modal_content" style="overflow: auto;">
      <div class="sh-grid-4">
        <img [src]="getImageUrl()">
      </div>
      <div class="sh-grid-6">
        <pre style="white-space: pre-wrap;font-family: inherit;font-size: 16px;">
          {{donationDrive.description}}
        </pre>
      </div>
    </div>
    <div class="ui_modal_btns">
      <a class="ui_btn ui_btn_primary" href="javascript:void(0)" (click)="action('donateNow')" >Donate now</a>
      <a class="ui_btn ui_btn_basic" href="javascript:void(0)" (click)="action('remindLater')">Remind me later</a>
    </div>
  </div>
</div>
